export default "__VITE_ASSET__1b6653d1__"